// extracted by mini-css-extract-plugin
module.exports = {"albumContainer":"styles_albumContainer__1505j","album":"styles_album__3M0LO","musics":"styles_musics__3rLii","musicCard":"styles_musicCard__q8_L4"};